import React from 'react'
import { CodeIcon } from '@heroicons/react/solid'
import { projects } from '../data/data'

const Projects = () => {
  return (
    <section id="projects">
      <div className="container px-5 py-10 mx-auto text-center lg:px-40">
        <div className="flex flex-col w-full mb-20">
          <CodeIcon className="mx-auto inline-block w-10 mb-4" />
          <h1 className="sm:text-4xl text-3xl font-medium title-font mb-4 text-black dark:text-white">
            Apps I've Built
          </h1>
          <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
            This is a small sample of my most recent work. For example,
            <a href="https://moksha-app.herokuapp.com/"> moksha</a>, which has
            been selected as one of the finalist projects for the IronHack's
            Hackshow in 2022. You can find more samples of my work in my
            <span>
              <a className="text-red-700" href="https://github.com/zerok1986">
                &nbsp;GitHub
              </a>
            </span>
          </p>
        </div>
        <div className="flex flex-wrap -m-4">
          {projects.map((project) => (
            <a
              href={project.link}
              key={project.image}
              className="sm:w-1/2 w-100 min-h-full p-4"
            >
              <div className="flex relative h-64">
                <img
                  alt="gallery"
                  className="absolute inset-0 w-full h-full object-cover object-center"
                  src={project.image}
                />
                <div className="px-8 py-10 relative align-middle z-10 w-full border-4 border-gray-800 bg-gray-100 dark:bg-gray-900 opacity-0 hover:opacity-100">
                  <h2 className="tracking-widest text-sm title-font font-medium text-red-700 mb-1">
                    {project.subtitle}
                  </h2>
                  <h1 className="title-font text-lg font-medium text-black dark:text-white mb-3">
                    {project.title}
                  </h1>
                  <p className="leading-relaxed">{project.description}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Projects



// WEBPACK FOOTER //
// ./src/components/pages/Projects.js